import React, { Fragment } from 'react'
import Link from 'gatsby-link'
import newsData from "../../whats-new-content";
import defaultImage from "../../images/ati_logo.jpg"
import { createHtmlText } from '../../helpers'

class Articles extends React.Component {


  renderHeroImage = (article) => {
    if (article.hero == null) {
      return defaultImage;
    } else {
      return article.hero;
    }
  }

  renderArticle = (article) => {
    if (article != null && article.data.type != "ad") {
      return (
        <article className="c-news__article--with-img">
        <img src={this.renderHeroImage(article)} alt="" className="c-news__article-img" />
        <div className="c-news__article-text">
          <h1 className="t-h2">{article.title}</h1>
          <p className="t-p t-p-light mt20" dangerouslySetInnerHTML={createHtmlText(article.intro)}/>
          <Link to={"/articles?id=" + article.id} className="c-btn t-link mt30">Read More</Link>
        </div>
        </article>
      );
    }
  }

  renderArticles = (newsData) => {

    var articleData = newsData.map((article) => this.renderArticle(article));
    return <div className="c-news o-container o-section">{articleData}</div>;
  }

  render() {
    return (
      this.renderArticles(newsData)
    );
  }
}

export default Articles;



// WEBPACK FOOTER //
// ./src/components/News/Articles.js